import React from "react";

const ContentLayout: React.FC = ({ children }) => {
  return <div>{children}</div>;
};

export default ContentLayout;
